import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Button
} from '@mui/material'
import { H4Text, BodyText } from '../../styles/AvantTypography'
import { AvantColors } from '../../styles/AvantColors'

interface TestTakerDeleteProps {
    DeleteTestTaker: () => void
    onClose: () => void
}

const DeleteTestTaker = ({ DeleteTestTaker, onClose }: TestTakerDeleteProps) => {

    return (
        <Dialog open={true} onClose={onClose} maxWidth="md" scroll="paper">
            <DialogTitle sx={{ p: 2, textAlign: "center" }}>
                        <H4Text style={{ fontWeight: 900, color: AvantColors.REPORT_FONT_COLOR_BLACK }}>
                            Confirm Deletion
                        </H4Text>
            </DialogTitle>

            <Divider sx={{ width: "100%", mb: 1 }} />

            <DialogContent>
                <TableContainer component={Paper} sx={{ borderRadius: 1, border: "1px solid #CDCDCD", boxShadow: "none" }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: "#F3F3F3" }}>
                            <TableRow>
                                <TableCell colSpan={3}>
                                    <BodyText>
                                        Are you sure you want to delete this test taker?
                                    </BodyText>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>

                <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        data-testid="delete-student"
                        onClick={DeleteTestTaker}
                    >
                        DELETE
                    </Button>
                    <Button
                        variant="outlined"
                        color="secondary"
                        fullWidth
                        data-testid="cancel-delete"
                        onClick={onClose}
                    >
                        CANCEL
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}

export default DeleteTestTaker